export const brand = {
  name: '热瓜速递',
  slogan: '每天第一手新鲜瓜，追热点不掉队',
  sloganShort: '天天有料',
  email: 'hello@regua.example.com',
  city: '线上内容平台',
};

export interface HotTopic {
  title: string;
  category: string;
  categorySlug: string;
  heat: string;
  up: number;
}

export const hotTopics: HotTopic[] = [
  { title: '新晋小花恋情疑曝光', category: '娱乐八卦', categorySlug: 'bagua', heat: '1284万', up: 18 },
  { title: '顶流居家综艺开播引热议', category: '明星资讯', categorySlug: 'mingxing', heat: '963万', up: 32 },
  { title: '网红人设崩塌全过程复盘', category: '网红爆料', categorySlug: 'wanghong', heat: '2104万', up: 76 },
  { title: '原创悬疑剧口碑炸裂', category: '影视综艺', categorySlug: 'yingshi', heat: '1750万', up: 54 },
  { title: '“已读不回”焦虑引发共鸣', category: '社会热点', categorySlug: 'shehui', heat: '431万', up: 9 },
  { title: '直播带货价格争议调查', category: '网红爆料', categorySlug: 'wanghong', heat: '762万', up: 27 },
  { title: '红毯造型盘点：惊艳与翻车', category: '明星资讯', categorySlug: 'mingxing', heat: '1530万', up: 41 },
  { title: '电子榨菜背后的年轻人生活', category: '社会热点', categorySlug: 'shehui', heat: '580万', up: 12 },
  { title: '从舞台到幕后的艺人转型', category: '明星资讯', categorySlug: 'mingxing', heat: '710万', up: 8 },
  { title: '中小创作者的限流焦虑', category: '网红爆料', categorySlug: 'wanghong', heat: '520万', up: 15 },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '热瓜速递的内容来源是什么？',
    a: '热瓜速递的内容由编辑团队围绕公开的行业动态、网络热议与作品信息进行整理和解读，坚持“信息来源可查、表述尽量客观”的原则，避免未经核实的情绪化表述。',
  },
  {
    q: '我看到的信息可以转载或引用吗？',
    a: '欢迎在注明出处的前提下进行有限引用。如需大篇幅转载或商业使用，请通过投稿联系页与我们取得授权，我们会尽快处理。',
  },
  {
    q: '如何投稿爆料或提供线索？',
    a: '你可以在“关于我们”页面的投稿表单中留下线索与联系方式，编辑团队会对每一条进行审核。对于可核实且有价值的素材，我们会在充分脱敏后跟进报道。',
  },
  {
    q: '发现内容有误该如何反馈？',
    a: '如果你发现某篇文章存在事实性错误或表述不当，请在投稿表单中选择“纠错反馈”，我们会核查并在核实后第一时间更正或下架相关内容。',
  },
  {
    q: '热瓜速递会做明星负面隐私的“实锤”吗？',
    a: '不会。我们关注的是公开作品、节目表现与话题讨论，尊重他人合法权益与隐私边界。娱乐可以玩梗，但边界与善意始终排在热度之前。',
  },
];

export interface ValueItem {
  title: string;
  desc: string;
  icon: string;
}

export const values: ValueItem[] = [
  { title: '真实优先', desc: '坚持信息来源可查、事件脉络完整，把“可核实”放在“够劲爆”之前。', icon: 'ri-shield-check-line' },
  { title: '多元栏目', desc: '娱乐八卦、明星资讯、网红爆料、影视综艺、社会热点，按兴趣轻松直达。', icon: 'ri-layout-grid-line' },
  { title: '理性吃瓜', desc: '围观热点也保持冷静，拒绝恶意揣测与断章取义，守护表达与隐私的边界。', icon: 'ri-eye-line' },
  { title: '陪伴与温度', desc: '在快节奏信息流里，为你的茶余饭后提供一点轻松、一点洞察与一点陪伴。', icon: 'ri-cup-line' },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  { name: '一颗桃桃', role: '娱乐八卦常客', text: '下班回家必刷“热瓜速递”的栏目，信息整理得很清爽，不用我自己满世界考古，省心又快乐。' },
  { name: '南山老王', role: '社会热点关注者', text: '难得见到吃瓜的同时还讲逻辑的内容，理性那部分的专栏我每篇都会看完，很戳我。' },
  { name: '追综小贝', role: '影视综艺追更党', text: '好剧好综的推荐都写到点子上了，按他们的安利追基本没踩过雷，血书多更。' },
];

export const socials = [
  { name: '微信', icon: 'ri-wechat-line' },
  { name: '微博', icon: 'ri-weibo-line' },
  { name: '小红书', icon: 'ri-message-3-line' },
  { name: '抖音', icon: 'ri-video-line' },
];